import React from 'react'
import { app, use, api } from 'xadmin'
import { Form } from 'xadmin-form'
import { SchemaForm } from 'xadmin-form';

import { Page, C } from 'xadmin-ui'
import { message } from 'antd';
import sha1 from 'crypto-js/sha1'

const schema = {
  type: 'object',
  properties: {
    old_password: {
      type: 'string',
      title: '原密码',
      maxLength: 30,
      fieldType: 'password',
    },
    new_password: {
      title: '新密码',
      type: 'string',
      maxLength: 30,
      fieldType: 'password',
    },
    new_password2: {
      title: '再次输入新密码',
      type: 'string',
      maxLength: 30,
      fieldType: 'password',
    },
  },
  form: [ 
    {
      key: 'old_password', attrs: { type: 'password' }, validate: value => (/^(?![^a-zA-Z]+$)(?!\D+$)/ig.test(value) ? null : '密码必须为字母与数字组合')
    },
    {
      key: 'new_password', attrs: { type: 'password' }, validate: value => (/^(?![^a-zA-Z]+$)(?!\D+$)/ig.test(value) ? null : '密码必须为字母与数字组合')
    },
    {
      key: 'new_password2', attrs: { type: 'password' }, 
      validate: (value, { new_password }) => value == new_password ? ((/^(?![^a-zA-Z]+$)(?!\D+$)/ig.test(value) ? null : '密码必须为字母与数字组合')) : '两次输入密码不一致'
    }
  ]
}


export default props => {

  const onChange = async (values) => {
    try {
      await api({ name: 'core/user/changepwd' }).save({
        ...values,
        old_password: sha1(values.old_password).toString(),
        new_password: sha1(values.new_password).toString(),
        new_password2: sha1(values.new_password2).toString()
      })
      message.success('修改密码成功')
      app.go('/login')
    } catch (err) {
      return (err.formError || err.json)
    }
  }

  return (
    <Page title="修改密码">
      <SchemaForm
        formKey={'changePassword'}
        schema={schema}
        component={C('Auth.ChangePassword') || C('Auth.Form')}
        onSubmit={onChange}
      />
    </Page>
  )
}
